import * as yup from "yup";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { HTTP_ENDPOINTS, QUERY_KEYS } from "../../consts/api";
import { http } from "../../services/HttpService";

const requestSchema = yup.object({
  file: yup.mixed().required(),
});

export function useAddFreeTaxableFileMutation(options = {}) {
  const queryClient = useQueryClient();

  return useMutation(
    (dto) => {
      const req = requestSchema.validateSync(dto, {
        strict: true,
      });

      const formData = new FormData();
      formData.append("file", req.file);

      return http.post(HTTP_ENDPOINTS.addFreeTaxabelFile(), formData);
    },
    {
      ...options,
      onSuccess: (...args) => {
        queryClient.invalidateQueries({
          queryKey: [QUERY_KEYS.account],
        });
        options.onSuccess?.(...args);
      },
    },
  );
}
